import { render } from "./Order-Beta.vue?vue&type=template&id=288fd830&scoped=true"
import script from "./Order-Beta.vue?vue&type=script&lang=js"
export * from "./Order-Beta.vue?vue&type=script&lang=js"

import "./Order-Beta.vue?vue&type=style&index=0&id=288fd830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288fd830"]])

export default __exports__